// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn.buttons_custom_value,
.btn.codd-bottom-button {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-height: 40px;
    padding: 10px 14px !important;
    border: none !important;
    border-radius: 12px !important;
    background: rgba(17, 24, 39, 0.94) !important;
    color: #ffffff !important;
    font-size: 13px !important;
    font-weight: 500;
    line-height: 1;
    box-shadow: 0 12px 28px rgba(15, 23, 42, 0.22);
}

.btn.buttons_custom_value:hover,
.btn.buttons_custom_value:active,
.btn.codd-bottom-button:hover,
.btn.codd-bottom-button:active {
    background: rgba(31, 41, 55, 0.98) !important;
    color: #ffffff !important;
}

.btn.buttons_custom_value:focus-visible,
.btn.codd-bottom-button:focus-visible {
    outline: 2px solid rgba(148, 163, 184, 0.85);
    outline-offset: 2px;
    box-shadow: 0 12px 28px rgba(15, 23, 42, 0.22);
}

.main-navbar {
    position: relative;
    z-index: 2500;
}

.main-navbar .dropdown-menu {
    z-index: 2600;
}
`, "",{"version":3,"sources":["webpack://./src/styles/reuse/buttons.css"],"names":[],"mappings":"AAAA;;IAEI,+BAA+B;IAC/B,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;IAChB,6BAA6B;IAC7B,uBAAuB;IACvB,8BAA8B;IAC9B,6CAA6C;IAC7C,yBAAyB;IACzB,0BAA0B;IAC1B,gBAAgB;IAChB,cAAc;IACd,8CAA8C;AAClD;;AAEA;;;;IAII,6CAA6C;IAC7C,yBAAyB;AAC7B;;AAEA;;IAEI,4CAA4C;IAC5C,mBAAmB;IACnB,8CAA8C;AAClD;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".btn.buttons_custom_value,\n.btn.codd-bottom-button {\n    display: inline-flex !important;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    min-height: 40px;\n    padding: 10px 14px !important;\n    border: none !important;\n    border-radius: 12px !important;\n    background: rgba(17, 24, 39, 0.94) !important;\n    color: #ffffff !important;\n    font-size: 13px !important;\n    font-weight: 500;\n    line-height: 1;\n    box-shadow: 0 12px 28px rgba(15, 23, 42, 0.22);\n}\n\n.btn.buttons_custom_value:hover,\n.btn.buttons_custom_value:active,\n.btn.codd-bottom-button:hover,\n.btn.codd-bottom-button:active {\n    background: rgba(31, 41, 55, 0.98) !important;\n    color: #ffffff !important;\n}\n\n.btn.buttons_custom_value:focus-visible,\n.btn.codd-bottom-button:focus-visible {\n    outline: 2px solid rgba(148, 163, 184, 0.85);\n    outline-offset: 2px;\n    box-shadow: 0 12px 28px rgba(15, 23, 42, 0.22);\n}\n\n.main-navbar {\n    position: relative;\n    z-index: 2500;\n}\n\n.main-navbar .dropdown-menu {\n    z-index: 2600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
